import React, { useState } from "react";
import {
  Typography,
  Box,
  TextField,
  Divider,
  Grid,
  Chip,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import DateAdapter from "@mui/lab/AdapterMoment";
import moment from "moment";
import "./Payment.css";
import "../App.css";
import { useFormik } from "formik";
import { paymentValidationSchema } from "../formValidation";

function Payment(props) {
  const [payLater, setPayLater] = useState(
    props.cafState.cafState.payment_method_type === "CHEQUE"
  );

  const formik = useFormik({
    initialValues: {
      bsb: props.paymentState.payment.paymentDetails.map((paymentDetails) => {
        return paymentDetails.bsb;
      }),
      accountNumber: props.paymentState.payment.paymentDetails.map(
        (paymentDetails) => {
          return paymentDetails.accountNumber;
        }
      ),
      dateOfBirth: props.personalState.user.identity.dob,
      idType: props.personalState.user.identity.idType,
      isDriversLicence:
        props.personalState.user.identity.idType === "Drivers Licence",
      idNumberDriversLicence: props.personalState.user.identity.idNumber,
      isPassport: props.personalState.user.identity.idType === "Passport",
      idNumberPassport: props.personalState.user.identity.idNumber,
      isMedicare: props.personalState.user.identity.idType === "Medicare",
      idNumberMedicare: props.personalState.user.identity.idNumber,
      idExpiry: props.personalState.user.identity.expiryDate,
    },
    validationSchema: paymentValidationSchema,
    validateOnChange: false,
    validateOnBlur: true,
  });
  const maxDateOfBirth = moment();
  maxDateOfBirth.set("year", maxDateOfBirth.year() - 18);

  // const handleUseSamePaymentMethodChange = (event) => {
  //   var newPayment = { ...props.paymentState.payment };
  //   newPayment.useSamePaymentMethod =
  //     !props.paymentState.payment.useSamePaymentMethod;
  //   props.paymentState.setPayment(newPayment);
  // };

  const handleBSBChange = (event, index) => {
    console.log(event.target.value);

    var newPayment = { ...props.paymentState.payment };
    let newCafState = { ...props.cafState.cafState };

    newPayment.paymentDetails[index].bsb = event.target.value;
    newCafState.direct_debit_number =
      event.target.value + newPayment.paymentDetails[index].accountNumber;
    props.paymentState.setPayment(newPayment);
    props.cafState.setCafState(newCafState);
  };

  const handleAccountNumberChange = (event, index) => {
    var newPayment = { ...props.paymentState.payment };
    let newCafState = { ...props.cafState.cafState };
    newPayment.paymentDetails[index].accountNumber = event.target.value;
    newCafState.direct_debit_number =
      newPayment.paymentDetails[index].bsb + event.target.value;
    props.paymentState.setPayment(newPayment);
    props.cafState.setCafState(newCafState);
  };

  const handleDOBChange = (value) => {
    var newPerson = { ...props.personalState.user };
    let newCafState = {
      ...props.cafState.cafState,
    };
    if (value == null) return;
    if (!value._isValid) {
      newPerson.identity.dob = null;
      newCafState.contact1_date_of_birth = null;
    } else {
      newPerson.identity.dob = value;
      newCafState.contact1_date_of_birth = value
        ? value.format("DD/MM/YYYY")
        : "";
    }
    props.personalState.setUser(newPerson);
    props.cafState.setCafState(newCafState);
  };

  const handleIDExpiryDateChange = (value) => {
    var newPerson = { ...props.personalState.user };
    let newCafState = { ...props.cafState.cafState };

    if (value == null) return;

    if (!value._isValid) {
      if (newPerson.identity.idType === "Drivers Licence") {
        newCafState.contact1_drivers_expiry = null;
      } else if (newPerson.identity.idType === "Passport") {
        newCafState.contact1_passport_expiry = null;
      }
    } else {
      newPerson.identity.expiryDate = value;
      if (newPerson.identity.idType === "Drivers Licence") {
        newCafState.contact1_drivers_expiry = value.format("DD/MM/YYYY");
      } else if (newPerson.identity.idType === "Passport") {
        newCafState.contact1_passport_expiry = value.format("DD/MM/YYYY");
      }
    }

    props.personalState.setUser(newPerson);
    props.cafState.setCafState(newCafState);
  };

  const handleIdentityTypeChange = (event) => {
    console.log(event.target.value);
    formik.setFieldValue("isPassport", event.target.value === "Passport");
    formik.setFieldValue(
      "isDriversLicence",
      event.target.value === "Drivers Licence"
    );
    formik.setFieldValue("isMedicare", event.target.value === "Medicare");
    var newPerson = { ...props.personalState.user };
    newPerson.identity.idType = event.target.value;
    props.personalState.setUser(newPerson);
  };

  const handleIdentityNumberChange = (event) => {
    var newPerson = { ...props.personalState.user };
    let newCafState = { ...props.cafState.cafState };

    if (newPerson.identity.idType === "Drivers Licence") {
      newCafState.contact1_drivers_licence = event.target.value;
    } else if (newPerson.identity.idType === "Passport") {
      newCafState.contact1_passport = event.target.value;
    } else {
      newCafState.contact1_medicard_no = event.target.value;
    }

    newPerson.identity.idNumber = event.target.value;
    props.personalState.setUser(newPerson);
    props.cafState.setCafState(newCafState);
  };

  const handlePayLaterChange = () => {
    setPayLater((prev) => !prev);

    var newPayment = { ...props.paymentState.payment };
    let newCafState = { ...props.cafState.cafState };

    newPayment.paymentDetails[0].bsb = "";
    newPayment.paymentDetails[0].accountNumber = "";
    newCafState.direct_debit_number = "";

    if (!payLater) {
      console.log("IT DO BE TRUE");
      newCafState.payment_method_type = "CHEQUE";
    } else {
      console.log("IT DO BE FALSE");

      newCafState.payment_method_type = "DIRECT";
    }

    formik.setFieldValue("bsb", [""]);
    formik.setFieldValue("accountNumber", [""]);
    formik.setFieldTouched("bsb", false);
    formik.setFieldTouched("accountNumber", false);
    props.paymentState.setPayment(newPayment);
    props.cafState.setCafState(newCafState);
  };

  return (
    <form name="PaymentForm" onSubmit={formik.handleSubmit}>
      <Box mb={5}>
        <Typography variant="h2">Billing Details</Typography>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Please fill in your payment details
        </Typography>
        {/* <Divider />

        <FormGroup id="group-payments-checkbox">
          <FormControlLabel
            control={
              <Checkbox
                checked={props.paymentState.payment.useSamePaymentMethod}
                onChange={handleUseSamePaymentMethodChange}
                name="useSamePaymentMethod"
              />
            }
            label={"Use the same payment method for connections?"}
          />
        </FormGroup> */}
        <Divider sx={{ mb: 1 }} />
        {props.paymentState.payment.useSamePaymentMethod ? (
          <>
            <Typography variant="h5" sx={{ mt: 2 }}>
              Direct Debit
            </Typography>
            <Typography variant="h6">
              Settle all your bills from a single bank account!
            </Typography>

            <Grid container spacing={2} sx={{ mb: 1 }}>
              <Grid item xs={6}>
                <TextField
                  id="bsb[0]"
                  name="bsb[0]"
                  data-cy="bsb-field"
                  label="BSB"
                  margin="normal"
                  disabled={payLater}
                  // type="number"
                  fullWidth
                  onChange={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      handleBSBChange(e, 0);
                      formik.handleChange(e);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.bsb[0]}
                  error={formik.touched.bsb && Boolean(formik.errors.bsb?.[0])}
                  helperText={formik.touched.bsb && formik.errors.bsb?.[0]}
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="accountNumber[0]"
                  name="accountNumber[0]"
                  data-cy="accNo-field"
                  label="Account Number"
                  margin="normal"
                  type="number"
                  disabled={payLater}
                  fullWidth
                  onChange={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      formik.handleChange(e);
                      handleAccountNumberChange(e, 0);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.accountNumber[0]}
                  error={
                    formik.touched.accountNumber &&
                    Boolean(formik.errors.accountNumber?.[0])
                  }
                  helperText={
                    formik.touched.accountNumber &&
                    formik.errors.accountNumber?.[0]
                  }
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
            </Grid>
          </>
        ) : (
          props.paymentState.payment.paymentDetails.map((item, index) => {
            return (
              <Box key={index}>
                <Typography variant="h5" sx={{ my: 2 }}>
                  {props.connections[index].planName}{" "}
                  <span
                    style={{
                      fontWeight: 300,
                    }}
                  >
                    | {" " + props.connections[index].address.description}
                  </span>
                </Typography>

                <Divider />

                <Grid container spacing={2} sx={{ mb: 1 }}>
                  <Grid item xs={6}>
                    <TextField
                      label="BSB"
                      id={`bsb[${index}]`}
                      name={`bsb[${index}]`}
                      margin="normal"
                      disabled={payLater}
                      // type="number"
                      fullWidth
                      onChange={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          handleBSBChange(e, index);
                          formik.handleChange(e);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.bsb[index]}
                      error={
                        formik.touched.bsb &&
                        Boolean(formik.errors.bsb?.[index])
                      }
                      helperText={
                        formik.touched.bsb && formik.errors.bsb?.[index]
                      }
                      onKeyDown={(evt) =>
                        evt.key === "," && evt.preventDefault()
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Account Number"
                      id={`accountNumber[${index}]`}
                      name={`accountNumber[${index}]`}
                      margin="normal"
                      type="number"
                      fullWidth
                      disabled={payLater}
                      onChange={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          formik.handleChange(e);
                          handleAccountNumberChange(e, index);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.accountNumber[index]}
                      error={
                        formik.touched.accountNumber &&
                        Boolean(formik.errors.accountNumber?.[index])
                      }
                      helperText={
                        formik.touched.accountNumber &&
                        formik.errors.accountNumber?.[index]
                      }
                      onKeyDown={(evt) =>
                        evt.key === "," && evt.preventDefault()
                      }
                    />
                  </Grid>
                  <Divider>
                    <Chip label="Or"></Chip>
                  </Divider>
                </Grid>
              </Box>
            );
          })
        )}
        <Divider>
          <Chip label="Or"></Chip>
        </Divider>
        <FormGroup id="pay-details-later-checkbox" sx={{ m: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                onChange={handlePayLaterChange}
                name="payDetailsLater"
                checked={payLater}
              />
            }
            label={
              <Typography variant="body" color={"gray"}>
                Use another payment method
              </Typography>
            }
          />
        </FormGroup>
        <Typography
          variant="body2"
          color={"gray"}
          textAlign="justify"
          hidden={!payLater}
        >
          We recommend setting up direct debit to avoid late payment fees, but
          you can pay using BPAY, bank transfer, credit card or cheque; further
          details will be on your first bill. <br />
          <br />
          If you would like to set up direct debit payment via Credit Card,
          please contact us after signing up on 1300 313 463.
        </Typography>
        <Typography variant="h5" sx={{ mt: 3 }}>
          Identity Information *
        </Typography>
        <Typography variant="h6">
          We just need to do a little credit check on our end
        </Typography>
        <Divider sx={{ m: 1, mb: 2 }} />
        <Grid container spacing={1}>
          <Grid item data-cy="dob-picker" sm={12} xs={12}>
            <LocalizationProvider dateAdapter={DateAdapter}>
              <DesktopDatePicker
                name="dateOfBirth"
                id="dateOfBirth"
                disableFuture
                maxDate={maxDateOfBirth}
                label="Date Of Birth"
                inputFormat="DD/MM/YYYY"
                value={formik.values.dateOfBirth}
                onChange={(value) => {
                  formik.setFieldValue("dateOfBirth", value, true);
                  handleDOBChange(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onBlur={(e) => {
                      formik.setFieldTouched("dateOfBirth");
                    }}
                    helperText={
                      formik.touched.dateOfBirth && formik.errors.dateOfBirth
                    }
                    error={
                      formik.touched.dateOfBirth &&
                      Boolean(formik.errors.dateOfBirth)
                    }
                    fullWidth
                    onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                  />
                )}
                data-cy="identity-dob-input"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item sm={12} xs={12}>
            <FormControl fullWidth>
              <InputLabel
                error={formik.touched.idType && Boolean(formik.errors.idType)}
                id="identityTypeLabel"
              >
                Please choose one Identity Type
              </InputLabel>
              <Select
                labelId="identityTypeLabel"
                id="idType"
                name="idType"
                data-cy="identityType"
                label="Please choose one Identity Type"
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  handleIdentityTypeChange(e);
                  formik.handleChange(e);
                }}
                value={formik.values.idType}
                error={formik.touched.idType && Boolean(formik.errors.idType)}
              >
                <MenuItem value={"Drivers Licence"}>Drivers Licence</MenuItem>
                <MenuItem value={"Passport"}>Passport</MenuItem>
                <MenuItem value={"Medicare"}>Medicare</MenuItem>
              </Select>
              <FormHelperText
                hidden={
                  !(formik.touched.idType && Boolean(formik.errors.idType))
                }
                error
              >
                {formik.errors.idType}
              </FormHelperText>
            </FormControl>
          </Grid>
          {formik.values.idType !== "" && formik.values.idType != null ? (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={
                  props.personalState.user.identity.idType !== "Medicare"
                    ? 7
                    : 12
                }
              >
                <TextField
                  required
                  id={`idNumber${formik.values.idType.replace(/\s/g, "")}`}
                  name={`idNumber${formik.values.idType.replace(/\s/g, "")}`}
                  data-cy="idNumber"
                  label={(formik.values.idType || "ID") + " Number"}
                  fullWidth
                  onChange={formik.handleChange}
                  onBlur={(e) => {
                    handleIdentityNumberChange(e);
                    formik.handleBlur(e);
                  }}
                  value={
                    formik.values[
                      `idNumber${formik.values.idType.replace(/\s/g, "")}`
                    ]
                  }
                  error={
                    formik.touched[
                      `idNumber${formik.values.idType.replace(/\s/g, "")}`
                    ] &&
                    Boolean(
                      formik.errors[
                        `idNumber${formik.values.idType.replace(/\s/g, "")}`
                      ]
                    )
                  }
                  helperText={
                    formik.touched[
                      `idNumber${formik.values.idType.replace(/\s/g, "")}`
                    ] &&
                    formik.errors[
                      `idNumber${formik.values.idType.replace(/\s/g, "")}`
                    ]
                  }
                  onKeyDown={(evt) => evt.key === "," && evt.preventDefault()}
                />
              </Grid>
              {formik.values.idType !== "Medicare" ? (
                <Grid item data-cy="expiry-date-picker" xs={12} sm={12} md={5}>
                  <LocalizationProvider dateAdapter={DateAdapter}>
                    <DesktopDatePicker
                      name="idExpiry"
                      id="idExpiry"
                      disablePast
                      label="Expiry Date"
                      inputFormat="DD/MM/YYYY"
                      value={formik.values.idExpiry}
                      onChange={(value) => {
                        formik.setFieldValue("idExpiry", value, true);
                        handleIDExpiryDateChange(value);
                        // formik.validateField("idExpiry");
                        // console.log(value);
                      }}
                      // onBlur={formik.setFieldTouched("idExpiry")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          onBlur={(e) => {
                            formik.setFieldTouched("idExpiry", true);
                          }}
                          helperText={
                            formik.touched.idExpiry && formik.errors.idExpiry
                          }
                          error={
                            formik.touched.idExpiry &&
                            Boolean(formik.errors.idExpiry)
                          }
                          fullWidth
                          onKeyDown={(evt) =>
                            evt.key === "," && evt.preventDefault()
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              ) : null}
            </>
          ) : null}
        </Grid>
      </Box>
    </form>
  );
}

export default Payment;
